import { defineComponent as r, openBlock as t, createBlock as p, unref as l, mergeProps as a, withCtx as i, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconSpinner",
  __name: "IconSpinner",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (t(), p(l(m), a(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M12 3.75A8.25 8.25 0 1 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25a.75.75 0 0 1 0 1.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
